import React from 'react';

function CloseButton({ onClick, variant, label = '✖' }) {
  return (
    <button className={`close-button--${variant}`} onClick={onClick}>
      {label}
    </button>
  );
}

export default CloseButton;
